import connection from "../connection";

const apiUrl = localStorage.getItem("apiUrl");

const resourceLogin = apiUrl + "/auth_token";
const resourceLogout = apiUrl + "/logout";

export default {
  /**
   * @param {string} username
   * @param {string} password
   */
  login(username, password) {
    return connection.post(resourceLogin, {
      username: username,
      password: password,
    });
  },
  /**
   * @param {string} username
   * @param {string} password
   */
  logout(username, password) {
    return connection.post(resourceLogout, {
      username: username,
      password: password,
    });
  },
};
